import {
  Card,
  CardBody,
  CardHeader,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import logo from "../../../assets/locandina_2026.jpeg";

export default function Locandina() {
  return (
    <Card bg="white" width="100%">
      <CardHeader m="auto">
        <Image src={logo} w={300} title="Locandina 2026" />
      </CardHeader>
      <CardBody>
        tes
        <Text>
          🎲Il 6 e 7 giugno 2026 Montagnana torna a riempirsi di gioco,
          fantasia, arte ed esperienze tutte da vivere.
          <br />
          <br />
          😍Quest’anno l’illustrazione porta la firma di Stefano Tamiazzo di
          Mind Academy, che ha dato forma all’universo Tales con tutta la
          creatività e l'energia che si respira solo qui 🎲⚡🏰
          <br />
          <br />
          TALES!
          <br />
          ...More than just comics and games
        </Text>
      </CardBody>
    </Card>
  );
}
